// import { useState, useEffect } from "react";
// import { useAuth } from "../Context/AuthContext";
// import API from "../Context/api";

// function EditDeliveryNoteForm({ id, setIsModalOpen, onDeliveryNoteUpdated }) {
//   const [deliveryNoteData, setDeliveryNoteData] = useState(null);
//   const [customer, setCustomer] = useState("");
//   const [items, setItems] = useState([]);
//   const [particulars, setParticulars] = useState("");
//   const [quantity, setQuantity] = useState("");
//   const [rate, setRate] = useState("");
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [vat, setVat] = useState(0);
//   const [finalTotalAmount, setFinalTotalAmount] = useState(0);
//   const [amountInWords, setAmountInWords] = useState("");
//   const [loading, setLoading] = useState(true);

//   const { user } = useAuth();
//   const createdBy = user ? user.name : "";

//   useEffect(() => {
//     const fetchDeliveryNote = async () => {
//       try {
//         const response = await API.get(`/deliverynotes/${id}`);
//         const deliveryNote = response.data;

//         console.log("Fetched Delivery Note:", deliveryNote);

//         setDeliveryNoteData(deliveryNote);
//         setCustomer(deliveryNote.invoiceDetails.client || "");
//         setItems(deliveryNote.invoiceDetails.items || []);
//         setTotalAmount(
//           deliveryNote.invoiceDetails.totalAmount -
//             deliveryNote.invoiceDetails.vat || 0
//         );
//         setVat(deliveryNote.invoiceDetails.vat || 0);
//         setFinalTotalAmount(deliveryNote.invoiceDetails.totalAmount || 0);
//         setAmountInWords(deliveryNote.invoiceDetails.amountInWords || "");
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching delivery note:", error);
//         alert("Failed to load delivery note data");
//         setLoading(false);
//       }
//     };

//     fetchDeliveryNote();
//   }, [id]);

//   useEffect(() => {
//     if (items !== null && items !== undefined && items.length > 0) {
//       const calculatedTotal = items.reduce(
//         (sum, item) => sum + (item.total || 0),
//         0
//       );
//       setTotalAmount(calculatedTotal);
//       const calculatedVat = Math.round(calculatedTotal * 0.18);
//       setVat(calculatedVat);
//       const finalTotal = calculatedTotal + calculatedVat;
//       setFinalTotalAmount(finalTotal);
//     } else {
//       setTotalAmount(0);
//       setVat(0);
//       setFinalTotalAmount(0);
//     }
//   }, [items]);

//   const addItem = () => {
//     if (particulars.trim() !== "" && quantity > 0 && rate > 0) {
//       const total = parseFloat(quantity) * parseFloat(rate);
//       setItems([...items, { particulars, quantity, rate, total }]);
//       setParticulars("");
//       setQuantity("");
//       setRate("");
//     }
//   };

//   const deleteItem = (index) => {
//     setItems(items.filter((_, i) => i !== index));
//   };

//   const updateDeliveryNote = async () => {
//     if (!customer.trim() || items.length === 0) {
//       alert("Please add a customer name and at least one item.");
//       return;
//     }

//     const updatedData = {
//       ...deliveryNoteData,
//       invoiceDetails: {
//         ...deliveryNoteData?.invoiceDetails,
//         client: customer,
//         items: items,
//         totalAmount: finalTotalAmount,
//         vat: vat,
//         amountInWords: amountInWords,
//       },
//       createdBy: createdBy || deliveryNoteData?.createdBy,
//     };

//     console.log(updatedData);

//     try {
//       await API.put(`/deliverynotes/${id}`, updatedData);
//       // onDeliveryNoteUpdated();
//       // setIsModalOpen(false);
//     } catch (error) {
//       console.error("Error updating delivery note:", error);
//       alert(
//         `Failed to update delivery note: ${error.message || "Unknown error"}`
//       );
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
//       <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
//         <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
//           <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
//             Edit Delivery Note
//           </h2>

//           <div className="mb-4">
//             <input
//               type="text"
//               className="border border-gray-300 p-2 rounded w-full mb-2"
//               placeholder="Customer Name"
//               value={customer}
//               onChange={(e) => setCustomer(e.target.value)}
//             />
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4">
//             <input
//               type="text"
//               className="border border-gray-300 p-2 rounded"
//               placeholder="Particulars"
//               value={particulars}
//               onChange={(e) => setParticulars(e.target.value)}
//             />
//             <input
//               type="number"
//               className="border border-gray-300 p-2 rounded"
//               placeholder="Qty"
//               value={quantity}
//               onChange={(e) => setQuantity(e.target.value)}
//             />
//             <input
//               type="number"
//               className="border border-gray-300 p-2 rounded"
//               placeholder="Rate (UGX)"
//               value={rate}
//               onChange={(e) => setRate(e.target.value)}
//             />
//             <button
//               onClick={addItem}
//               className="bg-blue-500 text-white px-4 py-2 rounded"
//             >
//               Add
//             </button>
//           </div>

//           <div className="flex-1 overflow-y-auto mb-4">
//             <table className="w-full border-collapse border border-gray-300">
//               <thead>
//                 <tr className="bg-gray-200">
//                   <th className="border p-2">Particulars</th>
//                   <th className="border p-2">Qty</th>
//                   <th className="border p-2">Rate (UGX)</th>
//                   <th className="border p-2">Total (UGX)</th>
//                   <th className="border p-2">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {items.map((item, index) => (
//                   <tr key={index} className="text-center">
//                     <td className="border p-2">{item.particulars}</td>
//                     <td className="border p-2">{item.quantity}</td>
//                     <td className="border p-2">{item.rate}</td>
//                     <td className="border p-2">{item.total}</td>
//                     <td className="border p-2">
//                       <button
//                         onClick={() => deleteItem(index)}
//                         className="bg-red-500 text-white px-2 py-1 rounded"
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div className="mt-4 text-right text-lg font-semibold text-gray-800">
//             <p>Sub Total: UGX {totalAmount.toLocaleString()}</p>
//             <p>VAT 18%: UGX {vat.toLocaleString()}</p>
//             <p>Grand Total: UGX {finalTotalAmount.toLocaleString()}</p>
//           </div>

//           <div>
//             <input
//               type="text"
//               className="border border-gray-300 p-2 rounded w-full my-2"
//               placeholder="Amount in words"
//               value={amountInWords}
//               onChange={(e) => setAmountInWords(e.target.value)}
//             />
//           </div>

//           <div className="mt-4 flex justify-end space-x-2">
//             <button
//               onClick={updateDeliveryNote}
//               className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
//             >
//               Update Delivery Note
//             </button>
//             <button
//               onClick={() => setIsModalOpen(false)}
//               className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default EditDeliveryNoteForm;

import { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import API from "../Context/api";
import ErrorMessage from "../Helpers/ErrorMessage";
import Spinner from "../Helpers/Spinner";

function EditDeliveryNoteForm({ id, setIsModalOpen, onDeliveryNoteUpdated }) {
  const [deliveryNoteData, setDeliveryNoteData] = useState(null);
  const [customer, setCustomer] = useState("");
  const [items, setItems] = useState([]);
  const [particulars, setParticulars] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [vat, setVat] = useState(0);
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [amountInWords, setAmountInWords] = useState("");
  const [isFetching, setIsFetching] = useState(true); // Track API fetch
  const [isLoading, setIsLoading] = useState(false); // Track form submission
  const [errorMessage, setErrorMessage] = useState("");

  const { user } = useAuth();
  const createdBy = user?.name || "";

  const parsePositiveNumber = (value) => {
    const number = parseFloat(value);
    return isNaN(number) || number <= 0 ? 0 : number;
  };

  useEffect(() => {
    const fetchDeliveryNote = async () => {
      if (!id) {
        setErrorMessage("Invalid delivery note ID");
        setIsFetching(false);
        return;
      }

      try {
        console.log("Fetching delivery note with ID:", id); // Debug log
        const response = await API.get(`/deliverynotes/${id}`);
        const deliveryNote = response.data;
        console.log("Fetched delivery note:", deliveryNote); // Debug log

        setDeliveryNoteData(deliveryNote);
        // Adjust based on actual API response structure
        setCustomer(
          deliveryNote.deliveryNoteDetails?.client ||
            deliveryNote.invoiceDetails?.client ||
            ""
        );
        setItems(
          deliveryNote.deliveryNoteDetails?.items ||
            deliveryNote.invoiceDetails?.items ||
            []
        );
        setTotalAmount(
          (deliveryNote.deliveryNoteDetails?.totalAmount ||
            deliveryNote.invoiceDetails?.totalAmount ||
            0) -
            (deliveryNote.deliveryNoteDetails?.vat ||
              deliveryNote.invoiceDetails?.vat ||
              0)
        );
        setVat(
          deliveryNote.deliveryNoteDetails?.vat ||
            deliveryNote.invoiceDetails?.vat ||
            0
        );
        setFinalTotalAmount(
          deliveryNote.deliveryNoteDetails?.totalAmount ||
            deliveryNote.invoiceDetails?.totalAmount ||
            0
        );
        setAmountInWords(
          deliveryNote.deliveryNoteDetails?.amountInWords ||
            deliveryNote.invoiceDetails?.amountInWords ||
            ""
        );
      } catch (error) {
        console.error("Error fetching delivery note:", error);
        setErrorMessage(
          error.response?.data?.message || "Failed to load delivery note data"
        );
      } finally {
        setIsFetching(false);
      }
    };

    fetchDeliveryNote();
  }, [id]);

  useEffect(() => {
    if (items?.length > 0) {
      const calculatedTotal = items.reduce(
        (sum, item) => sum + (item.total || 0),
        0
      );
      const calculatedVat = Math.round(calculatedTotal * 0.18);
      setTotalAmount(calculatedTotal);
      setVat(calculatedVat);
      setFinalTotalAmount(calculatedTotal + calculatedVat);
    } else {
      setTotalAmount(0);
      setVat(0);
      setFinalTotalAmount(0);
    }
  }, [items]);

  const addItem = () => {
    const qty = parsePositiveNumber(quantity);
    const price = parsePositiveNumber(rate);

    if (particulars.trim() && qty > 0 && price > 0) {
      const total = qty * price;
      setItems([...items, { particulars, quantity: qty, rate: price, total }]);
      setParticulars("");
      setQuantity("");
      setRate("");
      setErrorMessage("");
    } else {
      setErrorMessage("Please provide valid particulars, quantity, and rate");
    }
  };

  const deleteItem = (index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (confirmDelete) {
      setItems(items.filter((_, i) => i !== index));
    }
  };

  const updateDeliveryNote = async () => {
    if (!customer.trim() || items.length === 0) {
      setErrorMessage("Please add a customer name and at least one item");
      return;
    }

    setIsLoading(true);
    // const updatedData = {
    //   ...deliveryNoteData,
    //   deliveryNoteDetails: {
    //     ...deliveryNoteData?.deliveryNoteDetails,
    //     client: customer,
    //     items,
    //     totalAmount: finalTotalAmount,
    //     vat,
    //     amountInWords,
    //   },
    //   createdBy: createdBy || deliveryNoteData?.createdBy || "",
    // };

    const updatedData = {
      ...deliveryNoteData,
      customer: { client: customer },
      items,
      deliveryNoteDetails: {
        ...deliveryNoteData.deliveryNoteDetails,
        client: customer,
        items,
        totalAmount: finalTotalAmount,
        vat,
        amountInWords,
      },
      createdBy: createdBy || deliveryNoteData?.createdBy || "",
    };

    console.log("Updating delivery note with data:", updatedData); // Debug log

    try {
      await API.put(`/deliverynotes/${id}`, updatedData);
      onDeliveryNoteUpdated();
      // setIsModalOpen(false);
    } catch (error) {
      console.error("Error updating delivery note:", error);
      setErrorMessage(
        error.response?.data?.message || "Failed to update delivery note"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = customer.trim() && items.length > 0 && !isLoading;

  // if (isFetching) {
  //   return (
  //     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
  //       <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg p-4 text-center">
  //         <p className="text-gray-600">Loading delivery note...</p>
  //       </div>
  //     </div>
  //   );
  // }

  console.log("deliveryNoteData..................");
  console.log(deliveryNoteData);
  // if (errorMessage) {
  //   return (
  //     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
  //       <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg p-4">
  //         <ErrorMessage message={errorMessage} />
  //         <div className="flex justify-end mt-4">
  //           <button
  //             onClick={() => setIsModalOpen(false)}
  //             className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
  //           >
  //             Close
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
      <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col h-[90vh] sm:h-[80vh]">
        {/* Header */}
        <div className="p-4 border-b border-gray-200">
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">
            Edit Delivery Note
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>

        {isFetching && (
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10">
            <Spinner />
          </div>
        )}

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4">
          {/* Customer */}
          <input
            type="text"
            className="border border-gray-300 p-2 rounded w-full"
            placeholder="Customer Name"
            value={customer}
            onChange={(e) => setCustomer(e.target.value)}
          />

          {/* Item Inputs */}
          <div className="space-y-2 sm:space-y-0 sm:grid sm:grid-cols-4 sm:gap-2">
            <input
              type="text"
              className="border border-gray-300 p-2 rounded w-full"
              placeholder="Particulars"
              value={particulars}
              onChange={(e) => setParticulars(e.target.value)}
            />
            <input
              type="number"
              className="border border-gray-300 p-2 rounded w-full"
              placeholder="Qty"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
            <input
              type="number"
              className="border border-gray-300 p-2 rounded w-full"
              placeholder="Rate (UGX)"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />
            <button
              onClick={addItem}
              className="bg-blue-500 text-white px-4 py-2 rounded w-full disabled:bg-gray-300 disabled:cursor-not-allowed"
              disabled={
                particulars.trim() === "" ||
                parseFloat(quantity) <= 0 ||
                parseFloat(rate) <= 0
              }
            >
              Add
            </button>
          </div>

          {/* Items Table */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-200 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2 text-left">Particulars</th>
                  <th className="border p-2 text-left">Qty</th>
                  <th className="border p-2 text-left">Rate (UGX)</th>
                  <th className="border p-2 text-right">Total (UGX)</th>
                  <th className="border p-2 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="border p-2">{item.particulars}</td>
                    <td className="border p-2">{item.quantity}</td>
                    <td className="border p-2">{item.rate}</td>
                    <td className="border p-2 text-right">
                      {item.total.toLocaleString()}
                    </td>
                    <td className="border p-2 text-center">
                      <button
                        onClick={() => deleteItem(index)}
                        className="bg-red-500 text-white px-2 py-1 rounded text-xs hover:bg-red-600"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="text-right text-base font-semibold text-gray-800">
            <p>Sub Total: UGX {totalAmount.toLocaleString()}</p>
            <p>VAT (18%): UGX {vat.toLocaleString()}</p>
            <p>Grand Total: UGX {finalTotalAmount.toLocaleString()}</p>
          </div>

          {/* Amount in Words */}
          <input
            type="text"
            className="border border-gray-300 p-2 rounded w-full"
            placeholder="Amount in words"
            value={amountInWords}
            onChange={(e) => setAmountInWords(e.target.value)}
          />
        </div>

        {/* Footer Buttons */}
        <div className="p-4 border-t border-gray-200 flex flex-col sm:flex-row justify-end gap-2">
          <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 text-sm font-medium w-full sm:w-auto"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={updateDeliveryNote}
            disabled={!isFormValid}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
              !isFormValid
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            {isLoading ? "Submitting..." : "Update Delivery Note"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditDeliveryNoteForm;
